import {API_FE_DELETE_LOGIPARMA_DORMANT_CLIENT, API_FE_DOMAIN} from "../constants";
import { put, call } from 'redux-saga/effects';
import axios from "axios";
import {DELETE_LOGIPARMA_DORMANT_CLIENT_ERROR, DELETE_LOGIPARMA_DORMANT_CLIENT_SUCCESS} from "../reducers";
import deleteBoltDormantClientSaga from "./deleteBoltDormantClientSaga";

export default function* deleteLogiParmaDormantClientSaga(action) {
    try {
        const result = yield call(() => axios.post(
            API_FE_DOMAIN + API_FE_DELETE_LOGIPARMA_DORMANT_CLIENT,
             action.payload
        ));

        const response = result.data;

        if (response.status === 1) {
            const clientId = action.payload.clientId;
            yield call(deleteBoltDormantClientSaga, {payload: {clientId: clientId}});
/*
            yield put({
                type: DELETE_LOGIPARMA_DORMANT_CLIENT_SUCCESS,
                payload: response.data,
            });
*/
        } else {
            yield put({
                type: DELETE_LOGIPARMA_DORMANT_CLIENT_ERROR,
                payload: response.error,
            });
        }
    } catch (e) {
        console.log(e);
    }
}
